<template>
	<bsh-modal 
		titulo="Nova Despesa"
		tamanho="modal-lg"
		:name="name">
		<template v-slot:default>
	        <despesa-form
	        	:dados="dados" 
	        	:name="name" 
	        	:errors="errors">
	        </despesa-form>
	    </template>
	    <template v-slot:footer>
        	<button
				ref="btnRequest" 
        		type="button" 
        		class="btn btn-primary" 
        		@click="create">
        		Salvar
        	</button>
        </template>
    </bsh-modal>
</template>

<script>
	import Despesa from "./../../models/Despesa.js";
	export default {
		data(){
			return {
				dados: new Despesa(),
				name: 'create_despesa',
				errors: []
			}
		}, 
		methods: {
			create(){
				this.$btnFunctions.disableToggle(this.$refs.btnRequest, true)
	            axios.post(this.$url+'/api/adm/despesas/store', (this.dados))
	            .then(response => {
	            	$('#'+this.name).modal('hide')
	            	this.$bshMessage.show(response.data.message, response.data.type)
	              	this.dados = new Despesa()
	              	this.$emit('reload')
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
	            })
	            .catch(error => {
					this.errors = error.response.data.errors
					this.$btnFunctions.disableToggle(this.$refs.btnRequest, false)
				});
        	},
		},
	}
</script>